import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var Error = function Error(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#E01B25' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '2.4rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Error icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 24 24",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M11.338 2.40435C11.6387 1.86522 12.3613 1.86522 12.662 2.40435L22.8868 20.7373C23.2249 21.3435 22.7689 22 22.2249 22H1.77515C1.23114 22 0.775086 21.3435 1.11318 20.7373L11.338 2.40435Z",
    stroke: color,
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10C13 10.5523 12.5523 11 12 11C11.4477 11 11 10.5523 11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10H13V15H11V10Z",
    fill: color
  }));
};

export default Error;